import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const navItems = [
    { label: 'Início', path: '/', section: 'inicio' },
    { label: 'Serviços', path: '/', section: 'servicos' },
    { label: 'Soluções', path: '/', section: 'solucoes' },
    { label: 'Resultados', path: '/', section: 'resultados' },
    { label: 'Contato', path: '/', section: 'contato' },
  ];

  const scrollToSection = (section: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      window.setTimeout(() => {
        window.history.replaceState(null, '', section === 'inicio' ? '/' : `/#${section}`);
        document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
      }, 80);
    } else {
      window.history.replaceState(null, '', section === 'inicio' ? '/' : `/#${section}`);
      document.getElementById(section)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const isActive = (section: string) =>
    location.pathname === '/' && (section === 'inicio' ? !window.location.hash : window.location.hash === `#${section}`);

  return (
    <header ref={menuRef} className="flex items-center w-full justify-between px-5 py-3 lg:justify-evenly lg:px-6">
      {/* Logo */}
      <button onClick={() => { navigate('/'); setIsMenuOpen(false); }}>
        <img src="/Logo_Horiz_Cor_Branc_Maincode.svg" alt="MainCode" className="h-12 lg:h-14" />
      </button>

      {/* Mobile hamburger */}
      <button
        onClick={() => setIsMenuOpen(prev => !prev)}
        className="lg:hidden text-white p-1"
        aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
      >
        {isMenuOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white" className="h-6 w-6">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white" className="h-6 w-6">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        )}
      </button>

      {/* Nav links */}
      <div
        className={`fixed top-20 left-0 bg-[#0f0920] w-full z-50 transform transition-transform duration-300 ${
          isMenuOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:static lg:flex lg:w-auto lg:translate-x-0 lg:bg-transparent border-t border-white/5 lg:border-0`}
      >
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-1 p-6 lg:p-0">
          {navItems.map(item => (
            <button
              key={item.section}
              onClick={() => { scrollToSection(item.section); setIsMenuOpen(false); }}
              className={`text-sm font-medium px-4 py-2.5 rounded-lg transition-all w-full lg:w-auto text-left lg:text-center ${
                isActive(item.section)
                  ? 'text-white bg-white/10'
                  : 'text-white/70 hover:text-white hover:bg-white/10'
              }`}
            >
              {item.label}
            </button>
          ))}

          <button
            onClick={() => { navigate('/prospeccao'); setIsMenuOpen(false); }}
            className="mt-4 lg:mt-0 lg:ml-2 text-sm font-semibold text-white border border-white/30 hover:border-white/60 hover:bg-white/10 rounded-full px-5 py-2 transition-all"
          >
            Prospecção
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
